export const getAvgGrade = ( arr ) => 
{
    // Convert string to int values, then fold array
    let intArr = arr.map( elem => { return parseInt(elem) } );
    return intArr.reduce( (accumulator, currentValue) => accumulator + currentValue ) / intArr.length;
}